import axios from 'axios'

import { API_URL } from '../../../../../../constants'
import { DisputeRecord } from '../../../../matching/routes/Disputes/core/response.types'
import { CLIENT_DISPUTES_API } from './consts'
import { ClientDisputeQuery } from './query.types'

export interface ApiResponse<T> {
  success: boolean
  data: T | null
  totalRows?: number
}

/**
 * История диспутов одного клиента. Отдельный маршрут, а не `/dispute/list` с фильтром: журнал
 * мэтчинга фильтра по клиенту не имеет и получать его через query не должен (CPAYMENT-1732).
 */
export const getClientDisputes = (token: string, params: ClientDisputeQuery) =>
  axios.get<ApiResponse<DisputeRecord[]>>(`${API_URL}${CLIENT_DISPUTES_API}/${token}`, { params })
